module.exports = __webpack_public_path__ + "img/scene-campus.86f045c7.jpg";